import React, {useState} from 'react';
import { ReactSVG } from 'react-svg';

import { InnerContent } from '../../../modules/editor';

import ButtonModal from '../../../components/Button/ButtonModal';
import Modal from '../../../components/Modal/Modal';
import ImageCropper from '../../../components/ImageCropper/ImageCropper'

type Props = {
	innerContent: InnerContent;
	style: any;
	contentId: number;
	contentIndex: number;
	isLinkModalOpen?: boolean;
};

function MapToolbar({ innerContent, contentId, contentIndex, isLinkModalOpen }: Props) {
	const [showCropModal, setShowCropModal] = useState(false);
	const iconImage = require.context('../../../assets/images/', true);
	const contentTarget = `${contentId}/content/${contentIndex}`;

	const openCropModal = () => {		
		setShowCropModal(true);
	}

	const closeCropModal = () => {
		setShowCropModal(false);
	}	
	
	return (
		<>
			<div className="toolbar">
				<div className="group">
					<div className="btn-group">
						<ButtonModal
							target={`${contentTarget}`}
							value={innerContent}
							name="address"
							imagePath="icon/toolbar/pin"
							imageType="svg"
							valueType="text"
							isModalOpen={isLinkModalOpen}
							title="주소를 입력하세요"
						/>
					</div>
					<div className="btn-group">
						<ButtonModal
							target={`${contentTarget}`}
							value={innerContent}
							name="imageLink"
							imagePath="icon/toolbar/link"
							imageType="svg"
							title="URL을 입력하세요"
						/>
					</div>
					<div className="btn-group">
						<ButtonModal
							target={`${contentTarget}`}
							value={innerContent}
							name="imageAlt"
							imagePath="icon/toolbar/alt"
							imageType="svg"
							title="대체 텍스트를 입력하세요"
							valueType="alt"
						/>
					</div>
					{/* <div className="btn-group">
						<button 
							className={innerContent.imagePath?.includes('dummy_video') ? 'btn disabled' : 'btn'}
							onClick={openCropModal}
						>
							<ReactSVG src={iconImage(`./icon/toolbar/imageEditor.svg`)} height="16" />
						</button>
					</div> */}
				</div>
			</div>
			<Modal
				show={showCropModal}
				close={closeCropModal}
			>
				<ImageCropper
					target={`${contentTarget}/imagePath`}
					src={innerContent?.imagePath}
					onClose={closeCropModal}
				/>
			</Modal>
		</>
	);
}

export default MapToolbar;